export type TraceLog = {
  name: string;
  endTimeUnixNano: number;
  startTimeUnixNano: number;
  duration: number;
  parentSpanId: string;
  spanId: string;
  traceId: string;
  sessionId: string;
  statusCode: number;
  pageUrl: string;
  responseContentLength: number;
};

export const documentLoadSpan = (scope: any, ignoreUrls: Array<string | RegExp>): TraceLog[] => {
  const documentscope: TraceLog[] = [];

  if (scope) {
    const spans = scope["spans"] || [];
    if (spans.length > 0) {
      for (let i = 0; i < spans.length; i++) {
        const span = spans[i];
        const logSpan: any = {
          name: "",
          endTimeUnixNano: 0,
          startTimeUnixNano: 0,
          duration: 0,
          parentSpanId: "",
          spanId: "",
          traceId: "",
          sessionId: "",
          pageUrl: "",
          responseContentLength: 0,
          statusCode: 0
        };
        const instrumentationName = scope["scope"]["name"];
        if (instrumentationName === "@opentelemetry/instrumentation-fetch") {
          logSpan["name"] = "fetch";
        } else if (instrumentationName === "@opentelemetry/instrumentation-xml-http-request") {
          logSpan["name"] = "xhr";
        } else {
          logSpan["name"] = span["name"];
        }
        ["endTimeUnixNano", "startTimeUnixNano", "parentSpanId", "spanId", "traceId"].forEach((key) => {
          logSpan[key] = span[key];
        });
        logSpan["duration"] = span["endTimeUnixNano"] - span["startTimeUnixNano"];
        logSpan["sessionId"] = "";
        logSpan["pageUrl"] = "";
        logSpan["responseContentLength"] = 0;
        let discardTrace = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        for (let j = 0; j < span["attributes"].length; j++) {
          const item = span["attributes"][j];
          if (item["key"] === "http.url") {
            logSpan["pageUrl"] = item.value?.stringValue || "";
            if (ignoreUrls.some((url) => logSpan["pageUrl"].match(url) != null)) {
              discardTrace = true;
              break;
            }
          }
          if (item["key"] === "session_id") {
            logSpan["sessionId"] = item.value?.stringValue || "";
          }
          if (item["key"] === "http.response_content_length") {
            logSpan["responseContentLength"] = item.value?.intValue || 0;
          }
          if (item["key"] === "http.status_code") {
            logSpan["statusCode"] = item.value?.intValue || 0;
          }
        }
        if (!discardTrace) {
          documentscope.push(logSpan);
        }
      }
    }
  }
  return documentscope;
};
